import { PublicClientApplication, EventType, AuthenticationResult } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

export async function initializeMsal() {
    console.log("=> MSAL initialization..");
    try {
        await msalInstance.initialize();
        console.log("MSAL initialized successfully");
    } catch (error) {
        console.error("MSAL initialization error:", error);
    }

    msalInstance.enableAccountStorageEvents();

    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload ;
            const account = payload.account;
            msalInstance.setActiveAccount(account);
            console.log("Active account updated to:", account.username);
        }
    });
}

export const handleLogout = async (logoutType = "redirect") => {
  const activeAccount = await msalInstance.getActiveAccount();
  if (!activeAccount) {
    console.warn("No active account found during logout.");
    return;
  }

  if (logoutType === "popup") {
    await msalInstance.logoutPopup({ account: activeAccount }).catch((e) => {
      console.error(`logoutPopup failed: ${e}`);
    });
  } else if (logoutType === "redirect") {
    await msalInstance.logoutRedirect({
      account: activeAccount,
      postLogoutRedirectUri: import.meta.env.NEXT_PUBLIC_REDIRECT_URI,
    }).catch((e) => {
      console.error(`logoutRedirect failed: ${e}`);
    });
  }
};